(function() {
    const isMetaBrowser = /FBAN|FBAV|Instagram|FB_IAB|FBIOS|FBDV|Messenger/i.test(navigator.userAgent);
    
    if (!isMetaBrowser) return;

    function disableVideoAutoplay() {
        document.querySelectorAll('video[autoplay]').forEach(video => {
            video.removeAttribute('autoplay');
            video.pause();
            video.muted = true;
        });
    }

    disableVideoAutoplay();

    document.addEventListener('DOMContentLoaded', disableVideoAutoplay);

    const observer = new MutationObserver(disableVideoAutoplay);
    observer.observe(document.body, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['autoplay']
    });

    const originalInit = window.initVideoLoad;
    window.initVideoLoad = function() {
        if (originalInit) originalInit.apply(this, arguments);
        disableVideoAutoplay();
    };
})();